import { render, staticRenderFns } from "./PeriodSpecification.vue?vue&type=template&id=4ce12618&scoped=true"
import script from "./PeriodSpecification.vue?vue&type=script&lang=ts"
export * from "./PeriodSpecification.vue?vue&type=script&lang=ts"
import style0 from "./PeriodSpecification.vue?vue&type=style&index=0&id=4ce12618&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce12618",
  null
  
)

export default component.exports